export const WorkflowTriggerEnum = Object.freeze({
	FIRST_CONTACT: 'FIRST_CONTACT',
	FIRST_CONSULTATION_SCHEDULED: 'FIRST_CONSULTATION_SCHEDULED',
	CONTRACT_SIGNED: 'CONTRACT_SIGNED',
})
